import { z } from 'zod';
/**
 * The permissions an Account User can hold
 * (`patterns/auth-patterns.md`, 3). A new feature adds its permission here
 * first; the PostgreSQL `permission` enum is built from this same array
 * (`patterns/db-schema-conventions.md`, 5).
 */
export const PERMISSIONS = [
    'website_setup',
    'knowledge',
    'conversations_and_marks',
    'live_chat',
    'analytics',
    'billing_and_invoices',
    'users_and_permissions',
    'integrations',
];
export const permissionSchema = z.enum(PERMISSIONS);
/**
 * The name the dashboard shows for each permission, defined once
 * (`patterns/auth-patterns.md`, 3, Display names). A new permission adds its
 * display name here with it.
 */
/**
 * Permissions that only work alongside another: live chat happens inside
 * Conversations, so it needs the conversations and marks permission
 * (`patterns/auth-patterns.md`, 3). A permission set without the one it needs
 * is stored without it.
 */
export const PERMISSION_REQUIRES = {
    live_chat: 'conversations_and_marks',
    // Integrations send leads (the visitor's own details) out of Groundly, so
    // only someone who may see them can choose where they go.
    integrations: 'conversations_and_marks',
};
export const PERMISSION_DISPLAY_NAMES = {
    website_setup: 'Website setup',
    knowledge: 'Knowledge',
    conversations_and_marks: 'Conversations and marks',
    live_chat: 'Live chat',
    analytics: 'Analytics',
    billing_and_invoices: 'Billing and invoices',
    users_and_permissions: 'Users and permissions',
    integrations: 'Integrations',
};
/**
 * The nav order in `patterns/ui-patterns.md`, 2: Conversations, Analytics,
 * Knowledge, Website setup, Users and permissions, Billing. It decides "the
 * first nav item they hold" when the landing is worked out
 * (`GET /api/dashboard/me/landing`), and is shared so the navigation each
 * section feature adds uses the same order. Live chat has no nav item of its
 * own: it works inside Conversations, so it sits straight after it.
 */
export const navPermissionOrder = [
    'conversations_and_marks',
    'live_chat',
    'analytics',
    'knowledge',
    'website_setup',
    'integrations',
    'users_and_permissions',
    'billing_and_invoices',
];
//# sourceMappingURL=permissions.js.map